function onMouseWheel(event) {
  event.preventDefault();
  event.stopPropagation();
}

const root = document.getElementById('root');
root.addEventListener('wheel', onMouseWheel, { passive: false });
